import { render, staticRenderFns } from "./jfck.vue?vue&type=template&id=6b9ee2c9&"
import script from "./jfck.vue?vue&type=script&lang=js&"
export * from "./jfck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports